"use strict";

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.date.now");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var events_1 = require("events");
/**
 * Provides retrier service
 */


var Retrier =
/*#__PURE__*/
function (_events_1$EventEmitte) {
  _inherits(Retrier, _events_1$EventEmitte);

  /**
   * Creates a new Retrier instance
   */
  function Retrier(options) {
    var _this;

    _classCallCheck(this, Retrier);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Retrier).call(this));
    _this.minDelay = options.min;
    _this.maxDelay = options.max;
    _this.initialDelay = options.initial || 0;
    _this.maxAttemptsCount = options.maxAttemptsCount || 0;
    _this.maxAttemptsTime = options.maxAttemptsTime || 0;
    _this.randomness = options.randomness || 0;
    _this.inProgress = false;
    _this.attemptNum = 0;
    _this.prevDelay = 0;
    _this.currDelay = 0;
    return _this;
  }

  _createClass(Retrier, [{
    key: "attempt",
    value: function attempt() {
      clearTimeout(this.timeout);
      this.attemptNum++;
      this.timeout = null;
      this.emit('attempt', this);
    }
  }, {
    key: "nextDelay",
    value: function nextDelay(delayOverride) {
      if (typeof delayOverride === 'number') {
        this.prevDelay = 0;
        this.currDelay = delayOverride;
        return delayOverride;
      }

      if (this.attemptNum == 0) {
        return this.initialDelay;
      }

      if (this.attemptNum == 1) {
        this.currDelay = this.minDelay;
        return this.currDelay;
      }

      this.prevDelay = this.currDelay;
      var delay = this.currDelay + this.prevDelay;

      if (this.maxDelay && delay > this.maxDelay) {
        this.currDelay = this.maxDelay;
        delay = this.maxDelay;
      }

      this.currDelay = delay;
      return delay;
    }
  }, {
    key: "randomize",
    value: function randomize(delay) {
      var area = delay * this.randomness;
      var corr = Math.round(Math.random() * area * 2 - area);
      return Math.max(0, delay + corr);
    }
  }, {
    key: "scheduleAttempt",
    value: function scheduleAttempt(delayOverride) {
      var _this2 = this;

      if (this.maxAttemptsCount && this.attemptNum >= this.maxAttemptsCount) {
        this.cleanup();
        this.emit('failed', new Error('Maximum attempt count limit reached'));
        this.reject(new Error('Maximum attempt count reached'));
        return;
      }

      var delay = this.nextDelay(delayOverride);
      delay = this.randomize(delay);

      if (this.maxAttemptsTime && this.startTimestamp + this.maxAttemptsTime < Date.now() + delay) {
        this.cleanup();
        this.emit('failed', new Error('Maximum attempt time limit reached'));
        this.reject(new Error('Maximum attempt time limit reached'));
        return;
      }

      this.timeout = setTimeout(function () {
        return _this2.attempt();
      }, delay);
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      clearTimeout(this.timeout);
      this.timeout = null;
      this.inProgress = false;
      this.attemptNum = 0;
      this.prevDelay = 0;
      this.currDelay = 0;
    }
  }, {
    key: "start",
    value: function start() {
      var _this3 = this;

      if (this.inProgress) {
        throw new Error('Retrier is already in progress');
      }

      this.inProgress = true;
      return new Promise(function (resolve, reject) {
        _this3.resolve = resolve;
        _this3.reject = reject;
        _this3.startTimestamp = Date.now();

        _this3.scheduleAttempt(_this3.initialDelay);
      });
    }
  }, {
    key: "cancel",
    value: function cancel() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
        this.inProgress = false;
        this.emit('cancelled');
        this.reject(new Error('Cancelled'));
      }
    }
  }, {
    key: "succeeded",
    value: function succeeded(arg) {
      this.emit('succeeded', arg);
      this.resolve(arg);
    }
  }, {
    key: "failed",
    value: function failed(err, nextAttemptDelayOverride) {
      if (this.timeout) {
        throw new Error('Retrier attempt is already in progress');
      }

      this.scheduleAttempt(nextAttemptDelayOverride);
    }
  }, {
    key: "run",
    value: function run(handler) {
      var _this4 = this;

      this.on('attempt', function () {
        handler().then(function (v) {
          return _this4.succeeded(v);
        })["catch"](function (e) {
          return _this4.failed(e);
        });
      });
      return this.start();
    }
  }]);

  return Retrier;
}(events_1.EventEmitter);

exports.Retrier = Retrier;
exports["default"] = Retrier;